<div
  class="user-avatar"
  [class.user-avatar--round]="round"
  [style.width]="sizeCss"
  [style.height]="sizeCss"
  [style.font-size]="'calc(' + sizeCss + ' * 0.42)'"
>
  <img
    *ngIf="displaySrc; else fallback"
    [src]="displaySrc"
    [alt]="alt"
    (error)="onImgError()"
  />
  <ng-template #fallback>
    <span class="user-avatar__initial" aria-hidden="true">{{ initial }}</span>
  </ng-template>
</div>
